import { render } from "./BaseUploadButton.vue?vue&type=template&id=1458a56b&ts=true"
import script from "./BaseUploadButton.vue?vue&type=script&lang=ts"
export * from "./BaseUploadButton.vue?vue&type=script&lang=ts"

import "./BaseUploadButton.vue?vue&type=style&index=0&id=1458a56b&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__